<main data-testid="app-root">
  <router-outlet></router-outlet>
</main>

<app-toast />
<app-confirm-dialog />
